import React from 'react';
import { SummaryStats } from '../stats';
import { formatConnectMoney } from 'utils/currency';
import { DateFormat, dayjs } from 'utils/date';

type SummaryTilesProps = {
  stats: SummaryStats;
};

type Tile = { label: string; value: string };

const SummaryTiles: React.FC<SummaryTilesProps> = ({ stats }) => {
  const range =
    stats.firstPurchase && stats.lastPurchase
      ? `${dayjs(stats.firstPurchase).format(DateFormat.ll)} – ${dayjs(
          stats.lastPurchase
        ).format(DateFormat.ll)}`
      : '—';

  const tiles: Tile[] = [
    { label: 'Total spent', value: formatConnectMoney(stats.totalSpent) },
    { label: 'Orders', value: stats.orderCount.toLocaleString() },
    { label: 'Items', value: stats.itemCount.toLocaleString() },
    {
      label: 'Avg. order',
      value: formatConnectMoney(stats.averageOrder),
    },
    { label: 'Merchants', value: stats.merchantCount.toLocaleString() },
    { label: 'Date range', value: range },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
      {tiles.map((tile) => (
        <div
          key={tile.label}
          className="rounded-lg border border-emphasis40 p-4"
        >
          <div className="paragraph-20 text-grey">{tile.label}</div>
          <div className="heading-20 mt-1 break-words">{tile.value}</div>
        </div>
      ))}
    </div>
  );
};

export default SummaryTiles;
